import $ from 'jquery';

export default {
	init() {
		$('#salary-toggle').on('click', function() {
			let $toggle = $(this);
			if ($toggle.attr('aria-expanded') === "false") {
				$toggle.find('span').html('[-]');
			} else {
				$toggle.find('span').html('[+]');
			}		
		});
	},
};
